import { useEffect, useRef } from 'react';

/**
 * useEffect on mount
 */
export const useMountedEffect = <T extends () => unknown>(
  effect?: T,
  deps: unknown[] = [],
) => {
  const isMounted = useRef(false);
  const latest = useRef<T | undefined>(effect);
  useEffect(() => {
    latest.current = effect;
  });
  return useEffect(() => {
    let unmount: unknown;
    if (!isMounted.current && latest.current) {
      unmount = latest.current();
      isMounted.current = true;
    }
    return () => {
      isMounted.current = false;
      if (unmount) {
        return typeof unmount === 'function' ? unmount() : unmount;
      }
      return undefined;
    };
  }, deps);
};
